import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectOrderBook, selectQuickTradeQuoteSignature } from '../../../../selectors/security'
import { parseQuickTradeQuoteSignature } from '../../../../util/quickTradeQuote'
import QuickTradeQuantityField, { type QuickTradeQuantityFieldProps } from './QuickTradeQuantityField'

export type QuickTradeQuantityFieldWithLiveQuoteProps = Omit<
    QuickTradeQuantityFieldProps,
    'quote' | 'orderBook'
> & {
    liveQuoteSecurityKey: string
}

const QuickTradeQuantityFieldWithLiveQuote: React.FC<QuickTradeQuantityFieldWithLiveQuoteProps> = ({
    liveQuoteSecurityKey,
    ...fieldProps
}) => {
    const signature = useSelector(selectQuickTradeQuoteSignature(liveQuoteSecurityKey)) as string
    const orderBook = useSelector(selectOrderBook(liveQuoteSecurityKey))
    const quote = useMemo(() => parseQuickTradeQuoteSignature(signature), [signature])

    return <QuickTradeQuantityField {...fieldProps} quote={quote} orderBook={orderBook} />
}

export default memo(QuickTradeQuantityFieldWithLiveQuote)
